import template from './adpMenuToggler.html';
import controller from './adpMenuToggler.controller';
import './adpMenuToggler.less';

let adpMenuTogglerComponent = {
  restrict: 'E',
  bindings: {
  	menuOpened: '=?'
  },
  template,
  controller
};

export default adpMenuTogglerComponent;



// WEBPACK FOOTER //
// ./src/app/components/adpMenuToggler/adpMenuToggler.component.js